import type { Appointment } from "@rmh/defs";
import { DateTime } from "luxon";

export const sortAppointments = (appointment: Appointment[]) => {
  return appointment.sort((app1, app2) =>
    DateTime.fromISO(app1.appointmentDate)
      .diff(DateTime.fromISO(app2.appointmentDate))
      .toMillis()
  );
};
